import React, { useEffect, useState } from "react";
import ProductCard from "./ProductCard";
import { buttonIcon, titleIcon } from "../../assets/images";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { useParams } from "react-router-dom";

const Others = () => {
  const { t, i18n } = useTranslation();
  const { id } = useParams(); // id parametresi alındı
  const currentLanguage = i18n.language; // Aktif dili alıyoruz
  const [list, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [activeIndex, setActiveIndex] = useState(0);
  const [showText, setShowText] = useState(false);
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `https://www.elzabeauty.az/elza/dashboard.php`,
        { withCredentials: false }
      );

      // Hal-hazırda baxılan məhsulu çıxardıb qalan 4 məhsulu seçirik
      const filtered = response.data.data.filter(
        (product) => product.id.toString() !== id.toString()
      );
      const limitedData = filtered.slice(0, 4);

      setItems(limitedData);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  if (isLoading) {
    return <p className="text-center text-[white]">Loading...</p>;
  }

  return (
    <div className="max-w-containerSm md:max-w-container mx-auto mt-[88px] md:mt-[128px]">
      <div className="flex md:justify-between justify-center ">
        <div className="flex items-center">
          <img
            alt="Title"
            className="w-[50px] h-auto mr-2"
            src={titleIcon}
          ></img>
          <p className="text-[24px] md:text-[28px] font-semibold text-center md:text-left text-[#181D27]">
            {t("Digər məhsullarımız")}
          </p>
        </div>
        <a className="hidden md:block" href={`/${currentLanguage}/products`}>
          <div className="flex justify-between items-center text-[#181D27] w-[124px] h-[44px]">
            <p>{t("Hamısına bax")}</p>
          </div>
        </a>
      </div>
      <div className="hidden md:grid grid-cols-1 md:grid-cols-4 gap-4 mt-[40px]">
        {list.map((product) => {
          return (
            <ProductCard
              id={product.id}
              name={product.name}
              nameEn={product.nameEn}
              description={product.description}
              descriptionEn={product.descriptionEn}
              information={product.information}
              informationEn={product.informationEn}
              isNew={product.isNew}
              isBestseller={product.isBestseller}
              discount={product.discount}
              discountSituation={product.discountSituation}
              image1={product.image1}
              image2={product.image2}
              image3={product.image3}
              image4={product.image4}
              image5={product.image5}
            />
          );
        })}
      </div>
      <div className="block md:hidden mt-[48px] ">
        <Swiper
          slidesPerView={1}
          spaceBetween={20}
          loop={true}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          onSlideChange={(swiper) => {
            setShowText(false);
            setShowButton(false);
            setActiveIndex(swiper.activeIndex);
          }}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper"
        >
          {list.map((product, index) => {
            return (
              <SwiperSlide key={index}>
                <ProductCard
                  id={product.id}
                  name={product.name}
                  nameEn={product.nameEn}
                  description={product.description}
                  descriptionEn={product.descriptionEn}
                  information={product.information}
                  informationEn={product.informationEn}
                  isNew={product.isNew}
                  isBestseller={product.isBestseller}
                  discount={product.discount}
                  discountSituation={product.discountSituation}
                  image1={product.image1}
                  image2={product.image2}
                  image3={product.image3}
                  image4={product.image4}
                  image5={product.image5}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>

      <a className="block md:hidden" href={`/${currentLanguage}/products`}>
        <div className="flex justify-between items-center text-firstColor mt-[24px] h-[44px] w-[140px] mx-auto">
          <p>{t("Hamısına bax")}</p>
          <img alt="Titl" className="w-2" src={buttonIcon}></img>
        </div>
      </a>
    </div>
  );
};

export default Others;
